/**
 * AI feature highlights component for auth layout
 * Displays 3 random AI features with icons
 */

import { useMemo } from 'react';

import { Text } from '@/components/typography/Text/Text';
import { useTranslation } from '@/lib/i18n/hooks/use-translation';

import { getRandomFeatures } from '../functions/get-random-features';
import './AuthFeatures.scss';

export function AuthFeatures() {
  const { t } = useTranslation('auth');

  // Select 3 random features on mount - memoized to prevent re-randomization
  const features = useMemo(() => getRandomFeatures(), []);

  return (
    <div className="auth-features">
      {features.map((feature) => (
        <div key={feature.translationKey} className="auth-feature">
          <div className="auth-feature-icon">{feature.icon}</div>
          <Text size="sm" className="auth-feature-text" as="div">
            {t(feature.translationKey)}
          </Text>
        </div>
      ))}
    </div>
  );
}
